import { useAuth } from '@hostesa/auth-client';
import { type ReactNode, useEffect } from 'react';
import type { AppRouter } from '../router';
import { setAuthSnapshot } from './auth-bridge';

/**
 * Publishes the React-held auth state into the module-level snapshot that
 * router `beforeLoad` guards read, and invalidates the router so guards re-run
 * when auth changes (e.g. after login or session expiry). Render once, inside
 * `AuthProvider` and above `RouterProvider`.
 */
export function AuthBridge({ router, children }: { router: AppRouter; children: ReactNode }) {
  const { token, user, memberships, loading } = useAuth();

  useEffect(() => {
    setAuthSnapshot({ token, user, memberships, loading });
    // Re-evaluate guards with the fresh snapshot.
    void router.invalidate();
  }, [token, user, memberships, loading, router]);

  return <>{children}</>;
}
